export default "__VITE_ASSET__819330db__"